import { LegalPageLayout } from '../components/LegalPageLayout';
import { SEOHead } from '../components/SEOHead';

const AvisoLegal = () => {
  return (
    <LegalPageLayout title="Aviso Legal" lastUpdated="Febrero 2026">
      <SEOHead 
        title="Aviso Legal"
        description="Aviso legal de EventCinema.es - Información legal de Versión Digital S.L., condiciones de uso, propiedad intelectual y jurisdicción aplicable."
        keywords="aviso legal eventcinema, términos y condiciones, versión digital sl, lssi-ce"
        canonicalUrl="/aviso-legal"
        noIndex={false}
      />
      
      <p>
        En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad 
        de la Información y Comercio Electrónico (LSSI-CE), se exponen a continuación los datos 
        identificativos de la empresa titular de este sitio web.
      </p>

      <h2>1. Datos Identificativos</h2>
      <ul>
        <li><strong>Denominación Social:</strong> Versión Digital S.L.</li>
        <li><strong>NIF:</strong> B98660459</li>
        <li><strong>Domicilio Social:</strong> Calle Martínez Ferrando 6, CD. 46004, Valencia</li>
        <li><strong>Correo Electrónico:</strong> administracion@versiondigital.es</li>
        <li><strong>Datos de Inscripción en el Registro Mercantil:</strong> Tomo 9841, Libro 7123, Folio 13, Hoja V-161127</li>
      </ul>

      <h2>2. Objeto y Ámbito de Aplicación</h2>
      <p>
        El presente Aviso Legal regula el acceso, navegación y uso de la plataforma www.eventcinema.es 
        (en adelante, el "Sitio Web" o "Marketplace").
      </p>
      <p>
        Event Cinema es un marketplace especializado en la gestión y promoción de contenidos culturales 
        alternativos (ópera, ballet, arte, conciertos y eventos especiales) operado por Versión Digital S.L., 
        distribuidora líder en España. A través de este portal, se facilita la conexión entre los exhibidores 
        (cines) y los usuarios finales para la adquisición de entradas con condiciones especiales.
      </p>

      <h2>3. Condiciones de Uso</h2>
      <p>
        El acceso al Sitio Web le atribuye la condición de Usuario, lo cual implica la aceptación plena 
        y sin reservas de todas las disposiciones incluidas en este Aviso Legal. El Usuario se compromete a:
      </p>
      <ul>
        <li>Hacer un uso lícito de los contenidos y servicios.</li>
        <li>No realizar actividades fraudulentas o que puedan dañar la infraestructura de Event Cinema.</li>
        <li>Proporcionar información veraz en los procesos de registro y compra.</li>
      </ul>

      <h2>4. Propiedad Intelectual e Industrial</h2>
      <p>
        Todos los derechos de propiedad intelectual del contenido de este Sitio Web (incluyendo, a título 
        enunciativo: textos, imágenes, logotipos de la Royal Opera House, Arena de Verona, trailers de vídeo, 
        diseño gráfico y código fuente) pertenecen a Versión Digital S.L. o a terceros que han autorizado su uso.
      </p>
      <div className="highlight-box">
        <p>
          <strong>Importante:</strong> Queda estrictamente prohibida la reproducción, distribución o transformación 
          de cualquier contenido sin la autorización expresa y por escrito de Versión Digital S.L.
        </p>
      </div>

      <h2>5. Exclusión de Responsabilidad</h2>
      <p>
        Event Cinema actúa como plataforma de distribución y optimización de aforo en colaboración con los 
        exhibidores. Por tanto:
      </p>
      <ul>
        <li>
          <strong>Contenido:</strong> Aunque trabajamos por la máxima calidad, no nos hacemos responsables 
          de las variaciones de última hora en la programación que sean ajenas a la distribuidora 
          (ej: cambios técnicos en la sala de cine local).
        </li>
        <li>
          <strong>Disponibilidad:</strong> No garantizamos la ausencia de errores en el acceso a la web, 
          aunque pondremos todos nuestros recursos para evitarlos y subsanarlos.
        </li>
        <li>
          <strong>Enlaces Terceros:</strong> El Sitio Web puede contener enlaces a páginas de cines o 
          colaboradores. No asumimos responsabilidad por el contenido o las políticas de privacidad 
          de dichos sitios externos.
        </li>
      </ul>

      <h2>6. Protección de Datos y Cookies</h2>
      <p>
        Todo tratamiento de datos personales realizado a través de este Marketplace se regirá por nuestra{' '}
        <a href="/privacidad">Política de Privacidad</a> y nuestra{' '}
        <a href="/politica-cookies">Política de Cookies</a>, en estricto cumplimiento del RGPD 
        (Reglamento General de Protección de Datos) y la LOPDGDD.
      </p>

      <h2>7. Legislación Aplicable y Jurisdicción</h2>
      <p>
        Para la resolución de todas las controversias o cuestiones relacionadas con el presente sitio web 
        o de las actividades en él desarrolladas, será de aplicación la legislación española, a la que se 
        someten expresamente las partes, siendo competentes para la resolución de todos los conflictos 
        derivados o relacionados con su uso los Juzgados y Tribunales de Madrid (o el domicilio del 
        consumidor, en caso de que este sea aplicable por ley).
      </p>
    </LegalPageLayout>
  );
};

export default AvisoLegal;
